module.exports = __webpack_public_path__ + "media/images/farringdon-79136627.png";